/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketorderalreadypaidouterror5Inputs */

const en_ticketorderalreadypaidouterror5 = /** @type {(inputs: Ticketorderalreadypaidouterror5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This event was already paid out. Please refund the buyer directly.`)
};

const de_ticketorderalreadypaidouterror5 = /** @type {(inputs: Ticketorderalreadypaidouterror5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Event wurde schon ausgezahlt. Erstatte den Betrag bitte direkt an den Käufer.`)
};

/**
* | output |
* | --- |
* | "This event was already paid out. Please refund the buyer directly." |
*
* @param {Ticketorderalreadypaidouterror5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketorderalreadypaidouterror5 = /** @type {((inputs?: Ticketorderalreadypaidouterror5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketorderalreadypaidouterror5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketorderalreadypaidouterror5(inputs)
	return de_ticketorderalreadypaidouterror5(inputs)
});
export { ticketorderalreadypaidouterror5 as "ticketOrderAlreadyPaidOutError" }